import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const BarChartViz01 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey;
    };

    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key);
        if (filterCriteria[key].length === 0) {
          return true;
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    const filteredData = jsonData.filter(filterData);

    const locationCounts = filteredData.reduce((acc, item) => {
      const location = item.demographic_category_01;
      if (!acc[location]) {
        acc[location] = 0;
      }
      acc[location]++;
      return acc;
    }, {});

    const locationNames = Object.keys(locationCounts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = locationNames.map((location) => locationCounts[location]);

    setCategories(locationNames);
    setData(chartData);

    const optionsViz01 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: "100%", // Match the parent container height
        width: "100%", // Match the parent container width
      },
      plotOptions: {
        bar: {
          horizontal: true, // Set the bar orientation to horizontal
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28,
        style: {
          colors: ["#000"],
        },
      },
      xaxis: {
        categories: locationNames,
      },
    };

    const viz01 = new ApexCharts(
      document.querySelector("#viz-01"),
      optionsViz01
    );
    viz01.render();

    return () => {
      viz01.destroy();
    };
  }, [filterCriteria]);

  return (
    <div
      id="viz-01"
      style={{ width: "100%", height: "100%" }} // Ensure the container takes up full width and height
    ></div>
  );
};

export default BarChartViz01;
